import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=5057541b&scoped=true"
import script from "./SearchWidget.vue?vue&type=script&lang=js"
export * from "./SearchWidget.vue?vue&type=script&lang=js"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=5057541b&prod&lang=scss"
import style1 from "./SearchWidget.vue?vue&type=style&index=1&id=5057541b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5057541b",
  null
  
)

export default component.exports